import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { discoverLocationsListenerSaga } from './discover-locations';
import { listLocationsListenerSaga } from './list-locations';

export function* rootSaga(): SagaIterator {
    yield all([fork(discoverLocationsListenerSaga), fork(listLocationsListenerSaga)]);
}
